import { Container } from '@/components/shared/Container'
import React, { useState } from 'react'
import { StructuredText } from 'react-datocms'
import styled from 'styled-components'

type SourcesRecord = {
  id?: string
  sources: { value: any }
}

const StyledSources = styled.div`
  margin-top: 48px;
  padding: 38px 0;
  border: 2px solid ${(props) => props.theme.v2.onSurface.subdued.border};
  border-left: none;
  border-right: none;
  h3 {
    font-size: 32px;
    line-height: 48px;
    position: relative;
    display: inline-block;
    padding-right: 40px;
    margin: 0;
    cursor: pointer;
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      border: solid ${(props) => props.theme.colours.primary};
      border-width: 0 1px 1px 0;
      padding: 6px;
      transition: transform 0.25s ease-in;
      transform: translateY(-5px) rotate(45deg);
    }
  }
  .contents {
    max-height: 0;
    transition: max-height 0.3s ease-out;
    overflow: hidden;
    > p {
      font-size: 16px;
      line-height: 26px;
    }

    ol {
      margin-left: 0px;
      padding-left: 10px;
      li {
        color: ${(props) => props.theme.colours.secondary};
        font-weight: 400;
        margin: 22px;
        p {
          margin: 0px 10px;
          font-size: 16px;
          line-height: 24px;
        }
        a {
          font-weight: 400;
        }
      }
    }
  }
  &.active {
    h3 {
      &:after {
        transform: translateY(0px) rotate(-135deg);
      }
    }
    .contents {
      max-height: 10000px;
      transition: max-height 0.25s ease-in;
    }
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: 28px 0;
    h3 {
      font-size: 20px;
      line-height: 26px;
      padding-right: 20px;
      &:after {
        padding: 4px;
        transition: transform 0.25s ease-in;
      }
    }
    ol {
      li {
        p {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
`

type SourcesProps = {
  record: SourcesRecord
  title?: string
  expanded?: boolean
}

export const Sources: React.FC<SourcesProps> = ({ record, title = 'Sources', expanded = false }) => {
  const [expandSources, setExpandSources] = useState(expanded)

  return (
    <Container $size="narrow">
      <StyledSources className={expandSources ? 'active' : ''}>
        <h3 id="sources" onClick={() => setExpandSources(!expandSources)}>
          {title}
        </h3>
        <div className="contents">
          <StructuredText data={record.sources} />
        </div>
      </StyledSources>
    </Container>
  )
}
